import {
  getModule,
  initialize,
  loadSharedDep,
} from '../../pureCore/shared/moduleHandler';
import { init } from '../../ssrHydrationHelper/client/deserialize';

const globalsConfig = window.__IDUN_GLOBALS_CONFIG__;
const mfRemotes = window.__IDUN_MF_REMOTES__;

async function hydrate() {
  await initialize({ remotes: mfRemotes });

  const ReactDom = loadSharedDep('react-dom/client')();
  const React = loadSharedDep('react')();
  const { Globals } = loadSharedDep('@bwoty-web/ui-kit')();
  const { StoreProvider } = await getModule('idun/store');

  const afterDeserialization = async (topLevelNode, deserialisedContent) => {
    const StoreProviderElement = React.createElement(
      StoreProvider,
      { isServer: false },
      deserialisedContent,
    );

    const GlobalsElement = React.createElement(
      Globals,
      { ...globalsConfig },
      StoreProviderElement,
    );

    ReactDom.hydrateRoot(topLevelNode, GlobalsElement);
  };

  init(afterDeserialization, {
    getModule,
    deps: { React },
  });
}
hydrate();
